import { useEffect, useState } from "react";

const COLORS = ["#4F46E5", "#F59E0B", "#10B981", "#F43F5E", "#0284C7"];

export default function Celebration({ trigger, message }) {
  const [show, setShow] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!trigger) return;
    const p = Array.from({ length: 18 }, (_, i) => ({
      id: i,
      angle: (360 / 18) * i + Math.random() * 10,
      color: COLORS[i % COLORS.length],
      distance: 60 + Math.random() * 40,
    }));
    setParticles(p);
    setShow(true);
    const t = setTimeout(() => setShow(false), 1400);
    return () => clearTimeout(t);
  }, [trigger]);

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[100] pointer-events-none flex items-center justify-center" data-testid="celebration-overlay">
      <div className="relative">
        {particles.map((p) => (
          <span
            key={p.id}
            className="absolute w-2.5 h-2.5 rounded-full celebration-particle"
            style={{ backgroundColor: p.color, "--angle": `${p.angle}deg`, "--distance": `${p.distance}px` }}
          />
        ))}
        <div className="bg-card border-2 border-secondary rounded-2xl px-6 py-4 shadow-2xl animate-float-in">
          <p className="text-lg font-heading font-extrabold text-center whitespace-nowrap">{message}</p>
        </div>
      </div>
    </div>
  );
}
